import { Column } from 'primereact/column';
import Table from '../../../components/Table/Table';
import { useNavigate } from 'react-router-dom';
import {
  DataTablePFSEvent,
  DataTableRowClickEventParams,
} from 'primereact/datatable';
import { ApprovalSequenceSummary } from '../../../Interfaces/admin/ApprovalSequence.interface';
import { formatReportLabel } from '@/src/utils/roleUtils';

type ApprovalSequenceTableProps = {
  isFetching: boolean;
  isError: boolean;
  setPage: (page: number) => void;
  setRowsAmount: (rows: number) => void;
  sequencesData?: { sequences: ApprovalSequenceSummary[]; total: number };
  rowsAmount: number;
  page: number;
  backupSequencesData?: { sequences: ApprovalSequenceSummary[]; total: number };
  backupPage: number;
};

const ApprovalSequenceTable = ({
  isFetching,
  isError,
  setPage,
  setRowsAmount,
  sequencesData,
  rowsAmount,
  page,
  backupSequencesData,
  backupPage,
}: ApprovalSequenceTableProps) => {
  const navigate = useNavigate();

  const onPage = (event: DataTablePFSEvent) => {
    setPage(event.page ?? 0);
  };

  const calcHeight = (rows: number) => {
    const headerHeight = 32;
    const footerHeight = 61;
    const rowHeight = 36;
    return headerHeight + footerHeight + rows * rowHeight + 2;
  };

  const onRowClick = (event: DataTableRowClickEventParams) => {
    navigate(event.data.id);
  };

  return (
    <Table
      data={
        isError
          ? backupSequencesData?.sequences ?? []
          : sequencesData?.sequences ?? []
      }
      first={(isError ? backupPage : page) * rowsAmount}
      className={`tableStyled tablePrint`}
      rowClass={() => 'cursor-pointer'}
      lazy
      paginator
      loading={isFetching}
      totalRecords={isError ? backupSequencesData?.total : sequencesData?.total}
      onPage={onPage}
      calcHeight={calcHeight}
      defaultRowAmount={rowsAmount}
      onRowsAmountChange={setRowsAmount}
      onRowClick={onRowClick}
    >
      <Column
        field="company.name"
        header="Company"
        body={(approval) => {
          return <div className="capitalize">{approval.company.name}</div>;
        }}
        style={{ minWidth: '150px' }}
        headerClassName={`tableHeader font-normal`}
        className={`justify-content-center text-standard blackText tableCell`}
        footerClassName="tableFooter"
        sortable
      />
      <Column
        field="report"
        header="Report"
        body={(approval) => {
          return (
            <div className="capitalize">
              {formatReportLabel(approval.report)}
            </div>
          );
        }}
        style={{ minWidth: '150px' }}
        headerClassName={`tableHeader font-normal`}
        className={`justify-content-center text-standard blackText tableCell`}
        footerClassName="tableFooter"
        sortable
      />
    </Table>
  );
};

export default ApprovalSequenceTable;
